import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-ops-spinner-input',
    templateUrl: './ops-spinner-input.component.html',
    styleUrls: ['./ops-spinner-input.component.scss'],
    standalone: false
})
export class OpsSpinnerInputComponent implements OnChanges {
    @Output() valueChange = new EventEmitter<number>();
    @Input() title: string;
    @Input() value: number;

    @Input() min: number;
    @Input() max: number;

    ngOnChanges(changes: SimpleChanges): void {
        this.setValue(this.value);
    }

    incrementUp() {
        this.setValue(this.value + 1);
    }

    incrementDown() {
        this.setValue(this.value - 1);
    }

    setValue(value: number) {
        if (value == null || Number.isNaN(value)) value = this.min ?? this.max ?? 1;

        if (this.min != null) value = Math.max(this.min, value);

        if (this.max != null) value = Math.min(this.max, value);

        this.value = value;
        this.valueChange.emit(value);
    }
}
